// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Pgjs","signatureBlock":"Footer_signatureBlock__2tY9N","signature":"Footer_signature__1JRkW"};